import type { FeatureGate } from '../types'
import { Hashing } from '../utils/hashing'
import { getStatsigData } from '../utils/storage'

// Cada componente consulta o mesmo gate várias vezes por render; logar uma vez
// por gate por carregamento evita centenas de erros iguais por sessão no RUM.
const missingGatesLogged = new Set<string>()

export function getFeatureGate(gateName: string): FeatureGate | null {
  try {
    const data = getStatsigData()
    const gateNameHash = Hashing.djb2Hash(gateName)

    if (!data) {
      return null
    }

    const gate = data?.feature_gates[gateNameHash]

    if (!gate) {
      if (!missingGatesLogged.has(gateName)) {
        missingGatesLogged.add(gateName)
        console.error(`Feature gate "${gateName}" not found`)
      }

      return null
    }

    return gate
  } catch (error) {
    console.error('Error evaluating experiment:', error)

    return null
  }
}

export function useFeatureGate(gateName: string): FeatureGate | null {
  return getFeatureGate(gateName)
}
